exports.value = "qld-staging";